import { useTranslation } from 'react-i18next'

import { useAppContext } from 'client/hooks'
import { useGetCountries } from 'client/api'
import { TGetUserData } from 'client/api/useGetUser/useGetUser'

import {
  AppDivider,
  AppHeader,
  AppImage,
  AppParagraph,
  AppPopup,
} from 'client/ui-building-blocks'

import {
  humanizeFromToNow,
  isAccountConfirmed,
  getCountryFlagUrl,
  getAccountStatus,
} from 'client/services'

const Badge = ({ data }: TGetUserData) => {
  const { t, i18n } = useTranslation()

  const { data: countries } = useGetCountries({})
  const { authUser } = useAppContext()

  const accountStatus = getAccountStatus(authUser)

  const countryLabel =
    data &&
    countries?.[i18n.language.toLowerCase()].find(
      item => item.value === data.user.country
    ).text

  const src = getCountryFlagUrl(data?.user)

  const isProfileUserAuthUser = authUser._id.toString() === data?.user._id.toString()

  const displayEmailConfirmedIcon =
    isProfileUserAuthUser && isAccountConfirmed(accountStatus)

  const timePassed = humanizeFromToNow(data?.user.config.registeredAt, i18n.language)

  return (
    <>
      <AppHeader
        text={data?.user.username}
        size="xlarge"
        iconProps={
          displayEmailConfirmedIcon
            ? {
                name: 'CHECK',
                popupText: t('profilePage.badge.emailStatus.confirmed'),
                position: 'right',
                size: 'large',
              }
            : null
        }
      />
      <AppParagraph
        text={timePassed ? t('profilePage.badge.userSinceInfo', { timePassed }) : ''}
        size="small"
        color="secondary"
      />
      <AppDivider size="xxsmall" />
      <AppPopup text={countryLabel} position="top left">
        <AppImage src={src} height="48px" />
      </AppPopup>
    </>
  )
}

export default Badge
